/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PartnerAccountDetailAppData model module.
 * @module model/PartnerAccountDetailAppData
 * @version 1.0
 */
class PartnerAccountDetailAppData {
    /**
     * Constructs a new <code>PartnerAccountDetailAppData</code>.
     * @alias module:model/PartnerAccountDetailAppData
     */
    constructor() { 
        
        PartnerAccountDetailAppData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PartnerAccountDetailAppData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PartnerAccountDetailAppData} obj Optional instance to populate.
     * @return {module:model/PartnerAccountDetailAppData} The populated <code>PartnerAccountDetailAppData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PartnerAccountDetailAppData();

            if (data.hasOwnProperty('packageName')) {
                obj['packageName'] = ApiClient.convertToType(data['packageName'], 'String');
            }
            if (data.hasOwnProperty('appTitle')) {
                obj['appTitle'] = ApiClient.convertToType(data['appTitle'], 'String');
            }
            if (data.hasOwnProperty('developer')) {
                obj['developer'] = ApiClient.convertToType(data['developer'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PartnerAccountDetailAppData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PartnerAccountDetailAppData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['packageName'] && !(typeof data['packageName'] === 'string' || data['packageName'] instanceof String)) {
            throw new Error("Expected the field `packageName` to be a primitive type in the JSON string but got " + data['packageName']);
        }
        // ensure the json data is a string
        if (data['appTitle'] && !(typeof data['appTitle'] === 'string' || data['appTitle'] instanceof String)) {
            throw new Error("Expected the field `appTitle` to be a primitive type in the JSON string but got " + data['appTitle']);
        }
        // ensure the json data is a string
        if (data['developer'] && !(typeof data['developer'] === 'string' || data['developer'] instanceof String)) {
            throw new Error("Expected the field `developer` to be a primitive type in the JSON string but got " + data['developer']);
        }

        return true;
    }


}



/**
 * @member {String} packageName
 */
PartnerAccountDetailAppData.prototype['packageName'] = undefined;

/**
 * @member {String} appTitle
 */
PartnerAccountDetailAppData.prototype['appTitle'] = undefined;

/**
 * @member {String} developer
 */
PartnerAccountDetailAppData.prototype['developer'] = undefined;






export default PartnerAccountDetailAppData;

